import i18n from "../../../vendors/i18n/i18n";
export class SignUp {

  constructor(data) {

    this.businessName     = data.businessName    ||  '';
    this.rfc              = data.rfc             ||  '';
    this.tin              = data.tin             ||  '';
    this.names            = data.names           ||  '';
    this.firstSurname     = data.firstSurname    ||  '';
    this.secondSurname    = data.secondSurname;
    this.position         = data.position        ||  '';
    this.mobilePhoneCcc   = data.mobilePhoneCcc  ||  undefined;
    this.mobilePhone      = data.mobilePhone     ||  '';
    this.foreignmobilePhone = data.foreignmobilePhone ||  '';
    this.landLine         = data.landLine        ||  '';
    this.foreignlandLine  = data.foreignlandLine ||  '';
    this.email            = data.email           ||  '';
    this.confirmEmail     = data.confirmEmail    ||  '';
    this.lang             = data.lang            ||  'ES';
    this.origin           = { code: 'LOCAL',    description: i18n.t('signup.national') },
    this.legalEntity      = { code: 'LEGAL',    description: i18n.t('signup.moral-person') }
  }
}
